import { Badge } from 'antd';
import TcTooltip from 'components/UI/Tooltip/TcTooltip';
import endpointUrls from 'global/Constants/endpointUrls';
import routes from 'global/Constants/routes';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { OmOrdersNotInParcelManagment } from 'global/Models/omOrderModel';
import ApiService from 'global/utils/ApiService';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { RootState } from 'redux/store';

const UnregisteredOrdersToJet = () => {
  //states
  const [ordersFailedSendToJet, setOrdersFailedSendToJet] = useState<IBackendSearchGeneric<OmOrdersNotInParcelManagment>>();
  const [loading, setLoading] = useState<boolean>(false);
  const { customerUser } = useSelector((state: RootState) => state.user);

  //hooks
  const { pathname } = useLocation();
  const { push } = useHistory();

  //useEffetc
  useEffect(() => {
    customerUser?.customerId && getOmOrderList();
  }, [customerUser?.customerId]);

  //   const currentTime = new Date();
  //   const oneHourAgo = new Date(currentTime.getTime() - 60 * 60 * 1000); // Calculate time one hour ago
  //   const toCreationDate = dateObjectFormatter(oneHourAgo);
  //   console.log('oneHourAgo', oneHourAgo);
  //   console.log('ordersFailedSendToJet', ordersFailedSendToJet);
  // function
  const getOmOrderList = async () => {
    setLoading(true);
    await ApiService.post(endpointUrls.OmOrdersNotInParcelManagmentGetAll, {
      customerId: customerUser?.customerId,
      //   toCreationDate,
    })
      .then((res: IBackendSearchGeneric<OmOrdersNotInParcelManagment>) =>
        handleApiThenGeneric<IBackendSearchGeneric<OmOrdersNotInParcelManagment>, OmOrdersNotInParcelManagment[]>({
          res,
          notifFail: false,
          notifSuccess: false,
          onSuccess: setOrdersFailedSendToJet,
          onFailed: () => setOrdersFailedSendToJet(undefined),
        })
      )
      .catch(() => {});
    setLoading(false);
  };

  return (
    <>
      {ordersFailedSendToJet && !loading && pathname.startsWith('/dashboard') && ordersFailedSendToJet.data.length > 0 && (
        <TcTooltip title={`${ordersFailedSendToJet.totalItemCount} سفارش در صف ارسال `}>
          <Badge rootClassName='animate-pulse' count={ordersFailedSendToJet.totalItemCount} className='badge-rtl-fix'>
            <div
              onClick={() => push(routes.orderWaitingSendToJet.path)}
              className='px-2 py-1 mx-4 text-sm duration-300 border rounded-lg cursor-pointer border-t-error-color inherit-color hover:shadow-lg'>
              <span className='flex items-center justify-center gap-x-1 whitespace-nowrap'>در صف ارسال</span>
            </div>
          </Badge>
        </TcTooltip>
      )}
    </>
  );
};

export default UnregisteredOrdersToJet;
